import { Controller } from "@hotwired/stimulus"

// Connects via data-controller="cart" in the html view file
export default class extends Controller {

  static targets = ["cart"]

  connect() {
    document.addEventListener("cart:form", this.loadCartForm.bind(this));
    document.addEventListener("cart:show", this.showCart.bind(this))
  }

  disconnect() {
    document.removeEventListener("cart:form", this.loadCartForm.bind(this))
    document.removeEventListener("cart:show", this.showCart.bind(this))
  }

  // Event Handlers
  showCart(event) {
    // This opens the drawer and shows the current cart state (items, subtotals, etc.)
    const modal = document.querySelector("[data-controller='modal']");
    if (modal) {
      const modalController = this.application.getControllerForElementAndIdentifier(modal, "modal");
      const openEvent = new CustomEvent("modal:open", { detail: { size: "small" } });
      modalController?.open(openEvent);
      this.startLoading()
    }
    // Load the cart contents into the Turbo Frame
    Turbo.visit("/cart", { frame: "active-modal-content" })
    this.stopLoading()
  }

  loadCartForm(event) {
    this.startLoading()
    // This loads the shopping cart flow after clicking "Buy License" on a song version
    const { songVersionId } = event.detail;
    console.log('loadCartForm() for songVersion ID ', songVersionId)

    // Load the cart contents into the Turbo Frame
    Turbo.visit(`/song_versions/${songVersionId}/licenses`, {
      frame: "active-modal-content",
    })
    this.stopLoading()
  }

  customLicenseRequest(event) {
    const { id } = event.params;
    Turbo.visit(`/licensing/custom_request_form/${id}`, { frame: "active-modal-content" })
  }

  // Helper Methods
  pluralize(count, str) {
    return `${count} ${str}${count !== 1 ? "s" : ""}`
  }

  // Loading State
  startLoading() {
    this.element.classList.add("loading")
  }

  stopLoading() {
    this.element.classList.remove("loading")
  }
}
